import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import LogoMark from "@/components/LogoMark";

const footerLinks = [["About", "/about"], ["Services", "/services"], ["Industries", "/industries"], ["Contact", "/contact"]];

export default function SiteFooter() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="container footer-main">
        <div className="footer-intro">
          <Link to="/" data-testid="footer-brand-link"><LogoMark light /></Link>
          <p>Technology infrastructure with a sharper point of view for the businesses shaping Dubai.</p>
          <a className="footer-email" href="mailto:info@vortexcoreit.com" data-testid="footer-email-link">info@vortexcoreit.com <ArrowUpRight size={15} /></a>
        </div>
        <div className="footer-column">
          <span className="footer-label">Navigate</span>
          {footerLinks.map(([label, path]) => <Link key={path} to={path} data-testid={`footer-link-${label.toLowerCase()}`}>{label}</Link>)}
        </div>
        <div className="footer-column footer-address">
          <span className="footer-label">Dubai office</span>
          <p>Al Zahraa Techno Center<br />Office No. 101<br />Bur Dubai, Dubai, UAE</p>
          <span className="footer-micro">UAE / 25.2591° N, 55.2934° E</span>
        </div>
      </div>
      <div className="container footer-bottom">
        <span>© 2026 VORTEX CORE IT SERVICES LLC</span>
        <span>Hardware / Print / Network / Software</span>
      </div>
    </footer>
  );
}
